import { mq } from '@styles/vars/media-queries.style'
import { font } from '@styles/vars/font.style'
import { TextBody } from '@styles/vars/textStyles.style'
import { clamp } from '@styles/utils/conversion.style'
import styled from 'styled-components'


export const HeroMain = styled.section`
  background: ${props => props.background};
  color: ${props => props.color};
  ${clamp('padding-top', 140, 150)}
  ${clamp('padding-bottom', 40, 60)}
`

export const MainBox = styled.div`
  ${mq.tabletL} {
    display: grid;
    grid-template-columns: 1fr 1fr;
    grid-template-rows: 1fr 1fr 1fr 1fr;
  }
`

export const HeroTitle = styled.div`
  ${mq.tabletL} {
    grid-row-start: 1;
    grid-row-end: 4;
  }
  ${TextBody} {
    font-family: ${font.serif.family};
    ${clamp('font-size', 28, 68)}
    font-weight: ${font.serif.weight.light};
    line-height: 1.2;
    letter-spacing: -0.01em;

    strong {
      font-family: ${font.sans.family};
      font-weight: ${font.sans.weight.extrabold};
    }
  }
  .title h3 {
    ${clamp('font-size', 20, 40)};
    ${clamp('margin-top', 20, 50)};
    display: block;
  }
`

export const HeroImage = styled.div`
  ${mq.tabletL} {
    grid-row-start: 1;
    grid-row-end: 5;
    grid-column-start: 2;
    text-align: right;
    .gatsby-image-wrapper {
      width: 100%;
      height: calc(100% - 60px);
      max-width: 600px;
    }
  }
`

export const HeroSubTitleContainer = styled.div`
  display: flex;
  flex-flow: column;
  justify-content: end;
  ${mq.tabletLMax} {
    margin-top: 30px;
  }
`

export const HeroSubTitle = styled.div`
  display: flex;
  align-items: center;
  ${clamp('font-size', 22, 32)}
`

export const LogoContainer = styled.div`
  ${clamp('width', 118, 150)}
  margin-right: 10px;
`

export const BreadcrumbsMain = styled.nav`
  display: block;
  
`

export const BreadcrumbsList = styled.ol`
  display: flex;
  flex-wrap: wrap;
  list-style: none;
`

export const BreadcrumbsItem = styled.li`
  font-size: 16px;
  text-transform: uppercase;
  position: relative;
  &:not(:last-child) {
    padding-right: 15px;
    margin-right: 15px;
    &:after {
      content: "";
      position: absolute;
      top: 50%;
      right: 0px;
      transform: translateY(-50%);
      width: 0.2rem;
      height: 0.2rem;
      border-radius: 50%;
      background-color: currentcolor;
    }
  }
`

export const PageTitle = styled.h1`
  font-size: 13px;
  text-transform: uppercase;
  display: block;
  font-weight: bold;
  margin-top: 15px;
  ${clamp('margin-bottom', 30, 80)};
`